import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { PUBLICIP_SERVICE_KEY } from './publicIPEnum.js';

export default getGetterTypesForService(PUBLICIP_SERVICE_KEY);
